<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="formLabelCol">
        <a-row>
          <a-col :md="6" :sm="24" v-show="currentTab === '订单满足率'">
            <a-form-item label="计划类型">
              <global-select
                :value.sync="queryParams.planTypeList"
                selectType="selectMultiple"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'INV_ALLOCATION_PLAN_TYPE' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="currentTab === '订单满足率'">
            <a-form-item label="存放区域">
              <global-select
                :dropdown-match-select-width="false"
                :value.sync="queryParams.areaCodeList"
                selectType="selectMultiple"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'INV_DEFAULT_AREA' }"
                searchParam="lookupValue"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="currentTab === '订单满足率'">
            <a-form-item label="仓库">
              <a-input v-model="queryParams.warehouseName" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="currentTab === '安全库存水位'">
            <a-form-item label="物料编码">
              <a-input v-model="queryParams.itemCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="currentTab === '快递类产品维护'">
            <a-form-item label="物料编码">
              <a-input v-model="queryParams.itemCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiInvOrderSatisfyRateNewExport" ref="download" />
      <a-button v-show="currentTab === '订单满足率'" @click="$refs.orderSatisfactionRateAdd.show('订单满足率')" type="primary" v-hasPermi="['inv:invOrderSatisfyRate:add']">新建订单满足率</a-button>
      <a-button v-show="currentTab === '安全库存水位'" @click="$refs.orderSatisfactionRateAdd.show('安全库存水位')" type="primary" v-hasPermi="['inv:invSafetyStockLevel:add']">新建安全库存水位</a-button>
      <a-button v-show="currentTab === '快递类产品维护'" @click="$refs.orderSatisfactionRateAdd.show('快递类产品维护')" type="primary" v-hasPermi="['inv:invDeliveryProducts:add']">新建快递类产品维护</a-button>
      <a-button @click="handleExport" type="primary">导出</a-button>
      <a-button @click="importExcelHandleOpen" type="primary">导入</a-button>
      <a-button v-if="['订单满足率', '快递类产品维护'].includes(currentTab)" @click="onEdit" type="primary">编辑</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-tabs :default-active-key="currentTab" type="card" @change="tabOnchange">
          <a-tab-pane v-for="item in tabList" :key="item.key" :tab="item.key"></a-tab-pane>
        </a-tabs>
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: tableX }"
        >
          <span slot="satisfyRateTitle">
            <i class="toRequired">*</i>订单满足率
          </span>
          <span slot="oweGoodsDayTitle">
            <i class="toRequired">*</i>欠货天数
          </span>
          <span slot="calculationTypeTitle">
            <i class="toRequired">*</i>计算方式
          </span>
          <span slot="safetyStockLevelTitle">
            <i class="toRequired">*</i>安全库存水位
          </span>
          <span slot="flagTitle">
            <i class="toRequired">*</i>有效标识
          </span>
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a v-if="!isEdit || currentId !== record.id" @click="$refs.orderSatisfactionRateHistory.show(record, currentTab)" class="ml10">历史记录</a>
                <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
                <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
              </span>
              <span v-if="item.dataIndex === 'operationColumns3'">
                <a v-if="isEdit && currentId === record.id" @click="handleDeliveryProductsSave(record)">保存</a>
                <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
              </span>
              <span v-else-if="item.type === 'inputNumberOne'">
                <span v-if="!isEdit || currentId !== record.id">{{ record['satisfyRateBs'] }}</span>
                <a-input-number v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" :min="0" size="small" />
              </span>
              <span v-else-if="item.type === 'inputNumberTwo'">
                <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
                <a-input-number v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" :min="1" :precision="0" size="small" />
              </span>
              <span v-else-if="item.type === 'addPercent'">
                <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}%</span>
                <a-input-number v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" :min="1" :precision="0" size="small" />
              </span>
              <span v-else-if="item.type === 'integerInput'">
                <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
                <a-input-number
                  size="small"
                  v-if="isEdit && currentId === record.id"
                  v-model="record[item.dataIndex]"
                  :min="0"
                  :parser="(value) => `${value}`.replace(/\D/g, '')"
                  :formatter="(value) => `${value}`.replace(/\D/g, '')" />
              </span>
              <span v-else-if="item.type === 'calculationType'">
                <span v-if="!isEdit || currentId !== record.id">{{ record.calculationTypeName }}</span>
                <a-select size="small" v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" :allowClear="false">
                  <a-select-option v-for="(item) in calculationTypeList" :key="item.code" :value="item.code" :label="item.name">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </span>
              <span v-else-if="item.type === 'flag'">
                <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] === 'Y' ? '有效' : record[item.dataIndex] === 'N' ? '无效' : '' }}</span>
                <a-select size="small" v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]">
                  <a-select-option value="Y">有效</a-select-option>
                  <a-select-option value="N">无效</a-select-option>
                </a-select>
              </span>
              <span v-else-if="item.dataIndex === 'averageIncomingVolume'">
                <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
                <a-input-number v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" size="small"/>
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
        <!-- 新建 -->
        <order-satisfaction-rate-add
          :calculationTypeList="calculationTypeList"
          ref="orderSatisfactionRateAdd"
          @handle-success="handleOk"
        />
        <!-- 历史记录 -->
        <order-satisfaction-rate-history
          ref="orderSatisfactionRateHistory"
          @handle-success="handleOk"
        />
        <batch-edit-modal ref="satisfactionBatchEditModalRef" @finallyUpdate="noChangePage(true)" />
        <!-- 上传文件 -->
        <a-modal
          :title="upload.title"
          :visible="excelVisible"
          @ok="importExcelHandleCancel"
          @cancel="importExcelHandleCancel"
        >
          <a-upload-dragger
            name="file"
            accept=".xlsx, .xls"
            :multiple="true"
            :headers="upload.headers"
            :action="upload.url + '?updateSupport=' + upload.updateSupport"
            @change="importExcelHandleChange"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              请将文件拖拽到此处上传
            </p>
            <p class="ant-upload-hint">
              支持单个或批量上传，也可以点击后选择文件上传
            </p>
          </a-upload-dragger>
        </a-modal>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiUpdateOrderSatisfyRate,
  apiUpdateInvSafetyStockLevel,
  apiInvSafetyStockLevelList,
  apiInvOrderSatisfyRateNewExport,
  apiInvOrderSatisfyRateList,
  apiInvDeliveryProductsList,
  apiInvDeliveryProductsEdit
} from '@/api/mes/scheduling-plan/order-satisfaction-rate'
import OrderSatisfactionRateAdd from './components/order-satisfaction-rate-add'
import OrderSatisfactionRateHistory from './components/order-satisfaction-rate-history'
import { generateLsTableResData } from '@/utils/util.js';
import Cookies from 'js-cookie';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import deepClone from "lodash.clonedeep";
import batchEditModal from './components/satisfaction-batch-edit-modal.vue'
import { CALCULATION_TYPE_LIST } from './enum'
export default {
  // eslint-disable-next-line
  name: 'Order-satisfaction-rate', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {
    DownloadModal,
    OrderSatisfactionRateAdd,
    batchEditModal,
    OrderSatisfactionRateHistory
  },
  data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      apiInvOrderSatisfyRateNewExport,
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: ""
      },
      selectedRows: [],
      // 表格配置
      tableProps: {
        requestApi: "",
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      formLabelCol: { style: { width: '80px' } },
      // 查询参数
      queryParams: {
        planTypeList: undefined,
        areaCodeList: undefined,
        warehouseName: undefined,
        itemCode: undefined
      },
      calculationTypeList: CALCULATION_TYPE_LIST,
      // 表格数据
      tableList: [],
      // 表格字段
      columns: [],
      // 订单满足率
      columns1: [
        {
          title: '计划类型',
          dataIndex: 'planTypeName',
          align: 'center'
        },
        {
          title: '存放区域',
          dataIndex: 'areaCodeName',
          align: 'center',
          ellipsis: true
        },
        {
          // title: '订单满足率',
          dataIndex: 'satisfyRate',
          scopedSlots: { customRender: 'satisfyRate', title: "satisfyRateTitle" },
          width: 170,
          align: 'center',
          type: "inputNumberOne"
        },
        {
          // title: '欠货天数',
          dataIndex: 'oweGoodsDay',
          scopedSlots: { customRender: 'oweGoodsDay', title: "oweGoodsDayTitle" },
          width: 100,
          align: 'center',
          type: "integerInput"
        },
        {
          // title: '计算方式',
          dataIndex: 'calculationType',
          scopedSlots: { customRender: 'calculationType', title: "calculationTypeTitle" },
          width: 120,
          align: 'center',
          type: "calculationType"
        },
        {
          title: '仓库',
          dataIndex: 'wareHouseName',
          align: 'center'
        },
        // {
        //   title: '入库平均体积',
        //   dataIndex: 'averageIncomingVolume',
        //   width: 170,
        //   scopedSlots: { customRender: 'averageIncomingVolume' },
        //   align: 'center'
        // },
        {
          title: '最后更新人',
          dataIndex: 'updateName',
          align: 'center'
        },
        {
          title: '最后更新时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 170,
          align: 'center',
          type: "text"
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 170,
          align: 'center',
          type: "text"
        },
        {
          title: '操作',
          width: 120,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      // 安全库存水位
      columns2: [
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 150
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          ellipsis: true
        },
        {
          // title: '安全库存水位',
          dataIndex: 'safetyStockLevel',
          scopedSlots: { customRender: 'safetyStockLevel', title: "safetyStockLevelTitle" },
          width: 170,
          align: 'center',
          type: "inputNumberTwo"
        },
        {
          title: '最后更新人',
          dataIndex: 'updateName',
          align: 'center'
        },
        {
          title: '最后更新时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 170,
          align: 'center',
          type: "text"
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 170,
          align: 'center',
          type: "text"
        },
        {
          title: '操作',
          width: 120,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      // 快递类产品维护
      columns3: [
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 170,
          ellipsis: true
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          width: 170,
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          width: 250,
          ellipsis: true
        },
        {
          // title: '订单满足率',
          dataIndex: 'satisfyRate',
          scopedSlots: { title: "satisfyRateTitle", customRender: 'satisfyRate' },
          type: 'addPercent',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          // title: '有效标识',
          dataIndex: 'flag',
          scopedSlots: { title: "flagTitle", customRender: 'flag' },
          type: 'flag',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          // title: '欠货天数',
          dataIndex: 'oweGoodsDay',
          scopedSlots: { customRender: 'oweGoodsDay', title: "oweGoodsDayTitle" },
          width: 100,
          align: 'center',
          type: "integerInput"
        },
        {
          // title: '计算方式',
          dataIndex: 'calculationType',
          scopedSlots: { customRender: 'calculationType', title: "calculationTypeTitle" },
          width: 120,
          align: 'center',
          type: "calculationType"
        },
        {
          title: '最后更新人',
          dataIndex: 'updateName',
          align: 'center',
          width: 140,
          ellipsis: true
        },
        {
          title: '最后更新时间',
          dataIndex: 'updateTime',
          align: 'center',
          width: 170,
          ellipsis: true
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          align: 'center',
          width: 140,
          ellipsis: true
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          width: 170,
          ellipsis: true
        },
        {
          title: '操作',
          width: 120,
          dataIndex: 'operationColumns3',
          scopedSlots: { customRender: 'operationColumns3' },
          fixed: 'right'
        }
      ],
      // 页签
      currentTab: "订单满足率",
      tabList: [
        { key: "订单满足率" },
        { key: "安全库存水位" },
        { key: "快递类产品维护" }
      ],
      tableX: 1300,
      exportUrl: "" // 导出接口
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {
    this.tabOnchange("订单满足率")
  },
  mounted () {},
  methods: {
    // 页签-切换
    tabOnchange (val) {
      this.currentTab = val
      if (val === "订单满足率") {
        this.columns = JSON.parse(JSON.stringify(this.columns1))
        this.$set(this.tableProps, 'requestApi', generateLsTableResData(apiInvOrderSatisfyRateList, true));
        this.upload.url = process.env.VUE_APP_API_BASE_URL + '/inv/invOrderSatisfyRate/import'
        this.exportUrl = "inv/invOrderSatisfyRate/export"
      }
      if (val === "安全库存水位") {
        this.columns = JSON.parse(JSON.stringify(this.columns2))
        this.$set(this.tableProps, 'requestApi', generateLsTableResData(apiInvSafetyStockLevelList, true));
        this.upload.url = process.env.VUE_APP_API_BASE_URL + '/inv/invSafetyStockLevel/import'
        this.exportUrl = "inv/invSafetyStockLevel/export"
      }
      if (val === "快递类产品维护") {
        this.columns = deepClone(this.columns3)
        this.$set(this.tableProps, 'requestApi', generateLsTableResData(apiInvDeliveryProductsList, true));
        this.upload.url = process.env.VUE_APP_API_BASE_URL + '/inv/invDeliveryProducts/import'
        this.exportUrl = "inv/invDeliveryProducts/export"
      }
      this.resetQuery()
    },
    // 表单搜索
    onSearch (changePage = false) {
      this.isEdit = false;
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData(changePage);
    },
    // 批量编辑
    onEdit() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      this.$refs.satisfactionBatchEditModalRef.show(this.selectedRows, this.currentTab)
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }

      this.columns = JSON.parse(JSON.stringify(this.columns))
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      if (this.currentTab === "订单满足率" && !record.satisfyRate && String(record.satisfyRate) !== '0') {
        this.$message.error('订单满足率不能为空')
        return
      }
      if (this.currentTab === "安全库存水位" && !record.safetyStockLevel) {
        this.$message.error('安全库存水位不能为空')
        return
      }
      if(this.currentTab === "订单满足率") {
        if(!record.oweGoodsDay && record.oweGoodsDay !== 0) {
          this.$message.error('请输入欠货天数')
          return
        }
        if(!record.calculationType) {
          this.$message.error('请选择计算方式')
          return
        }
      }
      // 订单满足率
      if (this.currentTab === "订单满足率") {
        apiUpdateOrderSatisfyRate(record).then(response => {
          if (response.code === 200) {
            this.$message.success('保存成功')
            this.isEdit = false
            this.onSearch()
          } else {
            this.$message.error(response.msg)
          }
        })
      }
      // 安全库存水位
      if (this.currentTab === "安全库存水位") {
        apiUpdateInvSafetyStockLevel(record).then(response => {
          if (response.code === 200) {
            this.$message.success('保存成功')
            this.isEdit = false
            this.onSearch()
          } else {
            this.$message.error(response.msg)
          }
        })
      }
    },
    handleDeliveryProductsSave (record) {
      if (!record.satisfyRate && String(record.satisfyRate) !== '0') {
        this.$message.error('订单满足率不能为空')
        return
      }
      if (!record.flag) {
        this.$message.error('请选择有效标识')
        return
      }
      if(!record.oweGoodsDay && record.oweGoodsDay !== 0) {
        this.$message.error('请输入欠货天数')
        return
      }
      if(!record.calculationType) {
        this.$message.error('请选择计算方式')
        return
      }
      apiInvDeliveryProductsEdit(record).then(response => {
          if (response.code === 200) {
            this.$message.success('保存成功')
            this.isEdit = false
            this.onSearch()
          } else {
            this.$message.error(response.msg)
          }
        })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    // changePage为true，则不返回到第一页
    noChangePage (changePage = false) {
      this.onSearch(changePage)
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.$nextTick(() => {
        this.onSearch()
      })
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        planTypeList: undefined,
        areaCodeList: undefined,
        warehouseName: undefined,
        itemCode: undefined
      }
      this.handleQuery()
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.handleQuery()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    },
    /** 导出按钮操作 */
    handleExport () {
      if (this.currentTab === "订单满足率") {
        const params = this.queryParams
        this.$refs.download.openModal(params)
      } else {
        this.download(this.exportUrl, {
          ...this.queryParams
        }, `订单满足率标准_${this.currentTab}_${new Date().getTime()}.xlsx`)
      }
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-input-number{
  width: 100%;
}
/deep/.ant-select {
  width: 100%;
}
</style>
